export default __webpack_public_path__ + "static/media/promo-trends-light.8e51fc45.png";